import svg from '../assets/spinner.svg'
const LoaderIcon = (props) => <img {...props} src={svg} alt=""></img>
export default LoaderIcon
